import {useCallback} from 'react';
import {fetchHydratedUserEncounterList} from './plannerEncounterHydration';
import usePaginatedPlannerEncounterHistory from './usePaginatedPlannerEncounterHistory';

const PAGE_SIZE = 50;

export default function usePlannerEncounterHistory({
  userId,
  companyId = null,
  enabled = true,
  initialSeed = null,
  startDate = null,
  endDate = null,
  refreshKey = 0,
}: Record<string, any> = {}) {
  // Hydrate every page (initial fetch + load-more) the same way the seed is
  // hydrated in usePlannerSchedule, so paginated recent rows carry EHR/local
  // demographics before render instead of relying on the per-row fallback hook.
  const fetchPage = useCallback(
    (id: any, options: Record<string, any> = {}) =>
      fetchHydratedUserEncounterList(id, {
        ...options,
        companyId,
        startDate,
        endDate,
      }),
    [companyId, endDate, startDate],
  );

  return usePaginatedPlannerEncounterHistory({
    cacheKey: 'user-encounter-history',
    cacheScope: `${startDate || ''}:${endDate || ''}:r${refreshKey}`,
    enabled,
    errorLabel: 'planner encounter history',
    fetchPage,
    identity: userId,
    initialSeed: startDate || endDate || refreshKey ? null : initialSeed,
    pageSize: PAGE_SIZE,
  });
}
